export const i18nTexts = {
  leave_screen: {
    paragraph: "Comunícate con un asesor para poder iniciar una videollamada",
    button: "Ir a Bravo",
  },
  waiting_join_screen: {
    paragraph: "La sala a la que intentas unirte no existe o ya ha finalizado",
    button: "Ir a Bravo",
  },
  joining_screen: {
    name_input: "Ingresa tu nombre",
    button: "Únete a la videollamada",
    verify_audio_video: "Verifica tu audio y video",
    camera_off: "La cámara está apagada",
    not_permission: "No tienes permiso para usar tu micrófono y cámara",
    terms_and_conditions: "Para tu seguridad, esta llamada será grabada. Al permanecer en la llamada, aceptas nuestros términos y condiciones y la grabación de la misma.",
    mic_cam_notice: "Al entrar, tu cámara y micrófono estarán activados por defecto. Podrás desactivarlos en cualquier momento durante la llamada.",
    config: {
      setting: "Configuración de audio y video",
      audio: "Audio",
      video: "Video",
      mic: "Micrófono",
      webcam: "Cámara",
      select: "Seleccionar"
    }
  },
  meeting_screen: {
    header: {
      not_found: "No hemos podido encontrar los datos del lead",
      name: "Nombre",
      stage: "Etapa",
      total_debts: "Total de deudas",
      substage: "Subetapa",
      more_info: "Más información",
    },
    buttons: {
      recording_btn: {
        text: {
          is_recording: "La llamada se está grabando",
          not_recording: "La llamada no se está grabando",
        },
        tooltip: {
          recording_started: "Detener grabación",
          recording_starting: "Iniciando grabación",
          recording_stopped: "Comenzar grabación",
          recording_stopping: "Terminando grabación"
        },
      },
      screen_share_btn: {
        tooltip: {
          present: "Compartir pantalla",
          stop: "Detener la presentación",
        },
      },
      raise_hand_btn: {
        text: "Levantar la mano",
        tooltip: "Levantar la mano",
      },
      microphone_btn: {
        tooltip: {
          on: "Activar micrófono",
          off: "Desactivar micrófono",
        },
        selector: "Micrófono",
      },
      webcam_btn: {
        tooltip: {
          on: "Activar cámara",
          off: "Desactivar cámara",
        },
        selector: "Cámara",
      },
      leave_btn: {
        tooltip: "Salir de la reunión",
      },
      chat_btn: {
        tooltip: "Ver Chat",
        text: "Chat",
      },
      participants_btn: {
        tooltip: "Ver Participantes",
        text: "Participantes",
      },
    },
    views: {
      share: {
        local_present: "Tú estás presentando",
        client_present: "%{name} está presentando",
        advisor_present: "Asesor está presentando",
        text: "Estás presentando",
        stop_button: "Detener la presentación",
      },
      raised_hand: {
        local: "Tú levantaste la mano",
        client: "%{name} levantó la mano",
        advisor: "Asesor levantó la mano"
      },
      recording: {
        notify: {
          start: "La grabación ha comenzado",
          stop: "La grabación se ha detenido"
        }
      },
      chat: {
        local: "Tú",
        advisor: "Asesor",
        placeholder: "Escribe tu mensaje",
        notify: "dice"
      },
      participants: {
        local: "Tú",
        advisor: "Asesor"
      },
      error: {
        title: "Código de error",
        success_text: "OK"
      }
    },
    user: {
      name: "Visitante"
    }
  },
}
